import { useAuth } from '../contexts/AuthContext';
import { formatCurrency, getCurrencySymbol } from '../types';

export const useCurrency = () => {
  const { currentFamily } = useAuth();
  
  const currencyCode = currentFamily?.currency || 'USD';
  
  const formatAmount = (amount: number): string => {
    return formatCurrency(amount, currencyCode);
  };
  
  const getCurrencySymbol_ = (): string => {
    return getCurrencySymbol(currencyCode);
  };
  
  return {
    currencyCode,
    formatAmount,
    getCurrencySymbol: getCurrencySymbol_,
  };
};
